export default __webpack_public_path__ + "static/media/gaming_Footer_ISoftBet_Supplier.211488ef.svg";